import { render, staticRenderFns } from "./InscribetePage.vue?vue&type=template&id=09bb6c9c"
import script from "./InscribetePage.js?vue&type=script&lang=js&external"
export * from "./InscribetePage.js?vue&type=script&lang=js&external"
import style0 from "./InscribetePage.vue?vue&type=style&index=0&id=09bb6c9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports